export var isAsync = function (fn) { return fn.constructor.name === "AsyncFunction"; };
//# sourceMappingURL=async.js.map